const testimonials = [
  {
    name: "Elizabeth M.",
    location: "Wellington, FL",
    rating: 5,
    text: "My daughter had been invited to compete in a junior show jumping event in Belgium with two weeks' notice. We pulled her passport and discovered it had expired four months earlier. Fast Passport Center processed her renewal in four business days. She made the flight to Brussels, competed at the event, and placed third. Their team understood the urgency of equestrian competition travel in a way no other service did.",
    service: "Child Passport Renewal",
  },
  {
    name: "Thomas K.",
    location: "Wellington, FL",
    rating: 5,
    text: "I am a polo team manager based in Wellington during the season. One of our Argentine players had visa issues that required an emergency passport renewal before he could re-enter the United States. We had 72 hours. Fast Passport Center handled the entire process — from document review to submission — and the player had his passport in hand the morning of his flight back to Buenos Aires. Saved our season.",
    service: "Emergency Passport",
  },
  {
    name: "Rebecca S.",
    location: "Wellington, FL",
    rating: 5,
    text: "We live in Arden and booked a family Caribbean cruise for spring break — four of us, including our two children. I checked our passports two weeks before sailing and found that both kids' passports had expired. I panicked. Fast Passport Center walked me through the child passport process, I shipped everything overnight from the FedEx at Wellington Green, and both passports arrived four days later. We made the cruise with a day to spare.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function WellingtonTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Wellington Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Wellington equestrians, polo professionals, and families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}